import apiGetRequest from './base/api-get-request'
import { screenshotHeaders } from 'src/main_app/utils/screenshot-access'

const getPublicDataHeatMap = () => {
    return apiGetRequest(`/data-heatmap`)({ headers: screenshotHeaders() })
}

export default getPublicDataHeatMap
